import { PureComponent } from 'react';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';

class LoadingBar extends PureComponent {
  componentDidUpdate(previousProps) {
    const { count } = this.props;
    if (previousProps.count === 0 && count > 0)
      nprogress.start();
    else if (previousProps.count > 0 && count === 0)
      nprogress.done();
  }
  componentDidMount() {
    nprogress.configure({ showSpinner: false });
    if (this.props.count > 0)
      nprogress.start();
  }
  componentWillUnmount() {
    nprogress.done();
  }
  render() {
    return null;
  }
}

export default LoadingBar;
